module.exports = __webpack_public_path__ + "img/customer_design_10@2x.b1a6509.webp";